import { useState } from "react";
import apiClient from "../../../apiClient";
import { AttributeValue, EntityType, UnitDetail, UnitSearchResult, UnitStatus } from "./types";
import { notify } from "../../../utils";
import useUnit from "../../../customHooks/useUnit";

export default function useUnits() {
    const userUnit = useUnit();
    const [result, setResult] = useState<UnitSearchResult>();
    const [unit, setUnit] = useState<UnitDetail | null>(null);

    const searchAssetTag = async (q: string) => {
        if (!q.trim()) {
            setResult(undefined);
            return;
        }
        try {
            const res = await apiClient.get(`/inventory/asset-tag?assetTag=${q}&unit=${userUnit}`);
            setResult(res.data);
        } catch (err) {
            if (err.response.status == 404) {
                notify('Asset tag not found', 'error');
            }
        }
    };

    // const searchUnits = async (q: string) => {
    //     if (!q.trim()) {
    //         setResults([]);
    //         return;
    //     }
    //     const res = await apiClient.get(`/inventory/units`, { params: { q } });
    //     setResults(res.data);
    // };

    const loadUnit = async (serial: string) => {
        const res = await apiClient.get(`/inventory/units/${serial}?unit=${userUnit}`);
        setUnit(res.data);
    };

    const assignUnit = async (serial: string, entityType: EntityType, entityId: string) => {
        const res = await apiClient.post(`/inventory/units/${serial}/assign`, { entityType, entityId });
        return res.data as { serial: string; status: UnitStatus };
    };

    const revokeUnit = async (serial: string) => {
        const res = await apiClient.post(`/inventory/units/${serial}/revoke`);
        return res.data as { serial: string; status: UnitStatus };
    };

    const setUnitStatus = async (serial: string, toStatus: UnitStatus, reasonCategory?: string, note?: string, keepHolder?: boolean) => {
        const res = await apiClient.post(`/inventory/units/${serial}/status`, { toStatus, reasonCategory, note, keepHolder });
        return res.data as { serial: string; fromStatus: UnitStatus; toStatus: UnitStatus };
    };

    const patchUnit = async (serial: string, payload: { assetTag?: string | null; attributes?: Record<string, AttributeValue> }) => {
        const res = await apiClient.patch(`/inventory/units/${serial}`, payload);
        return res.data as { serial: string; updated: boolean };
    };

    return { result,  unit, setUnit, searchAssetTag, loadUnit, assignUnit, revokeUnit, setUnitStatus, patchUnit };
}
